module.exports = __webpack_public_path__ + "static/img/s409.6622fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s409.png
// module id = 561
// module chunks = 3